import { ContactType, type IUser } from '@condo/domain';

/**
 * External vs internal classification for the *current* logged-in user.
 *
 * Mirrors the contact-level rule used elsewhere in RAM and cockpit:
 * a user is external when their linked contact has `userId` set and a
 * `contactType` other than `User` (which represents internal Reneo
 * employees).
 *
 * Returns `false` when the user or their contact has not been loaded
 * yet — never assume external/internal until the data is present.
 */
export function userIsExternal(user: IUser | undefined): boolean {
    return user?.contactType !== ContactType.User;
}

export function userIsInternal(user: IUser | undefined): boolean {
    return user?.contactType === ContactType.User;
}
